function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31 0C22.7782 0 14.8934 3.26605 9.07983 9.07983C3.26605 14.8932 0 22.7784 0 31C0 39.2216 3.26605 47.1066 9.07983 52.9202C14.8932 58.7339 22.7784 62 31 62C39.2216 62 47.1066 58.7339 52.9202 52.9202C58.7339 47.1068 62 39.2216 62 31C62 25.5587 60.5676 20.2127 57.8469 15.5001C55.1258 10.7875 51.2127 6.87442 46.4999 4.15308C41.7873 1.43241 36.4413 0 31 0V0ZM31 58.1246C23.8062 58.1246 16.9073 55.2668 11.82 50.18C6.73326 45.0928 3.87541 38.1931 3.87541 31C3.87541 23.8069 6.73315 16.9073 11.82 11.82C16.9072 6.73326 23.8069 3.87542 31 3.87542C38.1931 3.87542 45.0927 6.73315 50.18 11.82C55.2667 16.9072 58.1246 23.8069 58.1246 31C58.1246 35.7616 56.8713 40.4388 54.4905 44.5624C52.1097 48.686 48.6858 52.11 44.5622 54.4907C40.4385 56.8715 35.7613 58.1248 30.9998 58.1248L31 58.1246Z",
  fill: "#FF4106"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.3298 21.4094L40.5898 18.6694L30.9998 28.2595L21.4097 18.6694L18.6697 21.4094L28.2597 30.9995L18.6697 40.5896L21.4097 43.3296L30.9998 33.7395L40.5898 43.3296L43.3298 40.5896L33.7398 30.9995L43.3298 21.4094Z",
  fill: "#FF4106"
});

var SvgExpire = function SvgExpire(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExpire, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Expire.2b9f7a47.svg";
export { ForwardRef as ReactComponent };